export enum FinishRegistrationMethod {
  confirmPassword = 'confirmPassword',
  signUpViaSalesman = 'signUpViaSalesman',
}
